import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { analytics } from "../lib/analytics";

const MESSAGES = [
  "Namaste! Want the full rate sheet?",
  "Book a free discovery call — no obligation.",
  "We reply within one business day.",
];

export default function AvatarBubble() {
  const [visible, setVisible] = useState(true);
  const [msgIndex, setMsgIndex] = useState(0);
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    if (!visible) return;
    const msgTimer = setInterval(() => setMsgIndex((i) => (i + 1) % MESSAGES.length), 4500);
    const frameTimer = setInterval(() => setFrame((f) => (f + 1) % 2), 2400);
    return () => {
      clearInterval(msgTimer);
      clearInterval(frameTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <motion.div
      data-testid="avatar-assistant"
      initial={{ opacity: 0, x: -60 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 2.4, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 left-6 z-50 flex items-end gap-3"
    >
      <motion.button
        data-testid="avatar-figure-button"
        onClick={() => { analytics.ctaClick("avatar_assistant", "floating"); window.__lenis?.scrollTo(document.querySelector("#contact"), { offset: -76, duration: 1.4 }); }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.94 }}
        className="relative cursor-pointer"
        aria-label="Talk to the TaccTax assistant"
      >
        <span className="absolute inset-x-1 bottom-0 h-6 rounded-full bg-bluedark/25 blur-md" aria-hidden="true" />
        <motion.div
          animate={{ y: [0, -8, 0], rotate: [-1.5, 1.5, -1.5] }}
          transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          className="relative w-[92px] h-[108px] sm:w-[112px] sm:h-[132px]"
        >
          <AnimatePresence>
            {[0, 1].map((f) => (
              <motion.img
                key={f}
                src={f === 0 ? "/avatar_wave.png" : "/avatar_point.png"}
                alt=""
                initial={{ opacity: 0 }}
                animate={{ opacity: frame === f ? 1 : 0 }}
                transition={{ duration: 0.35 }}
                className="absolute inset-0 w-full h-full object-contain object-bottom"
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </motion.button>

      <motion.div
        data-testid="avatar-speech-bubble"
        key={msgIndex}
        initial={{ opacity: 0, y: 10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
        className="relative mb-6 glass rounded-2xl rounded-bl-sm px-4 py-3 shadow-soft max-w-[170px] sm:max-w-[210px]"
      >
        <p className="text-xs font-semibold text-ink leading-snug pr-4">{MESSAGES[msgIndex]}</p>
        <button
          data-testid="avatar-close"
          onClick={() => setVisible(false)}
          className="absolute top-1.5 right-1.5 text-slate-400 hover:text-ink transition-colors cursor-pointer"
          aria-label="Dismiss assistant"
        >
          <X size={13} />
        </button>
      </motion.div>
    </motion.div>
  );
}
